// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__5m6Qr","tag":"Info_tag__Ls5BX","icons":"Info_icons__sttZ7"};